// extracted by mini-css-extract-plugin
export default {"backToReferrer":"_zmwy0n"};